
export interface MarkAllAsReadRequest {
  recipientId: string;
}
